module.exports = "/assets/data/0f1ca62fb50e537b5eb4cdaceed3c798-G81.data.json";